// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module_root-2l7Of","word":"index-module_word-3ZCDG"};